import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { FileUploadIcon } from '../../icons/FileUploadIcon';
import { UploadProductsFeedsModal } from '../../modals/UploadProductsFeedsModal';
import { fetchProductsFeeds } from '../../../store/actions/productsFeeds';
import { alertSuccess } from '../../../store/actions/alert';

import styles from './ProductsFeedsActions.module.scss';

export function ProductsFeedsActions() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchAfterWait = () => setTimeout(() => dispatch(fetchProductsFeeds()), 500);

  return (
    <>
      <div className={styles.actionsWrapper}>
        <button type="button" className={styles.button} onClick={() => setIsModalOpen(true)}>
          <FileUploadIcon />
        </button>
      </div>
      <UploadProductsFeedsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUpload={() => {
          fetchAfterWait();
          dispatch(alertSuccess('file is being processed, a summary email will be sent'));
        }}
      />
    </>
  );
}
